import { isEmpty } from "lodash";
import api from "../../../../api";
import {
  assignDoctorCheck,
  getCurrentUserRole,
  isExternalMedrep,
  prescriptionAgentCheck,
  TOAST_MESSAGE_CSS,
} from "modules/utilities/utility";
import { toast } from "react-toastify";
import { BLOCKED_ACCESS} from "../../../utilities/utility";

export function getCategoryFlowSelection(ticketId) {
  return api.get(`/get-category-flow-selection/${ticketId}`);
}

export function getCustomerData(case_id, signal) {
  if(case_id === '8ef2dce0-6816-4bd4-b29d-b77b659ef0a9' && !BLOCKED_ACCESS){
    return null;
  }
  const apiEndpoint = isExternalMedrep
    ? `v2/case/${case_id}`
    : `/case/${case_id}`;
  return api.get(apiEndpoint, { signal });
}

export function getProductMapping() {
  return api.get(`product_mapping`);
}

export function getDiscountCodes() {
  return api.get(`discount-codes`);
}

export function getFreshChatData(customer_id) {
  return api.get(`/freshchat/${customer_id}`);
}

export function getRecentCommentData(customer_id) {
  return api.get(`case/${customer_id}/comments`);
}

export function getEngagementResponseData(customer_id) {
  return api.get(
    `api/authDashboard/lead-engagement-response/${customer_id}`
  );
}

export function getActivityLogData(customer_id, pageNumber) {
  return api.get(
    `case/${customer_id}/activityLog?pageNumber=${pageNumber}&pageSize=50`
  );
}

export function setActivityLogData(caseId, eventId, meta = {}) {
  return api.post(`/case/${caseId}/activityLog`, { eventId, meta });
}

export function getNearestClinics(params) {
  const queryParams = new URLSearchParams();
  if (params.pincode) queryParams.append('pincode', params.pincode);
  // Set latitude and longitude to 1 by default if not provided
  // queryParams.append('latitude', params.latitude || 1);
  // queryParams.append('longitude', params.longitude || 1);
  if (params.radius) queryParams.append('radius', params.radius);
  if (params.limit) queryParams.append('limit', params.limit);

  // Using the clinic API endpoint
  return api.get(`api/clinic/nearest-clinics?${queryParams.toString()}`);
}

export function getAvailableDoctorsData() {
  const apiEndpoint = isExternalMedrep
    ? `v2/role_doctors?is_unified_ticketing=true`
    : `role_doctors?is_unified_ticketing=true`;
  return api.get(apiEndpoint);
}

export function getAvailableInterventionDoctorsData() {
  const apiEndpoint = 'intervention-doctors-list';
  return api.get(apiEndpoint);
}

export function getAssignedDoctorsData(customer_id) {
  if (assignDoctorCheck.includes(getCurrentUserRole())) {
    return api.get(`/assigned_doctors/${customer_id}`);
  }
}

export function getPrescriptionData(order_id) {
  if (prescriptionAgentCheck.includes(getCurrentUserRole())) {
    const apiEndpoint = isExternalMedrep
      ? `v2/prescription/${order_id}`
      : `prescription/${order_id}`;
    return api.get(apiEndpoint);
  }
}

export function getEngagementsData(order_id) {
  return api.get(`v2/engagements?order_id=${order_id}&state=null`);
}

export function getFeedbackData(order_id) {
  return api.get(`engagement-feedback/${order_id}`);
}

export function setShippingPending(order_id) {
  return api.put(`order/${order_id}/markShippingPending`);
}

export function setBulkOrderCount(duration, order_id) {
  return api.post(`bulkOrder`, { duration, order_id });
}

export function getConsultFeedBack(case_id) {
  return api.get(`case/${case_id}/v2/consult_call`);
}

export function getChatDuplicateList(phoneNumber) {
  const encodedPhoneNumber = encodeURIComponent(
    "+91" + phoneNumber.replace("+91", "")
  );
  return api.get(`chat_duplicate_list?chat_phone_number=${encodedPhoneNumber}`);
}
export function setUserProfile(id, changedDeatils) {
  return api.put(`/customer/${id}/edit`, { ...changedDeatils });
}

export function setConsultFeedback(id, changedDeatils) {
  return api.post(`case/${id}/v4/consult_call`, {
    feedback: changedDeatils,
    tag: "general",
  });
}

export function setDirectOrder(id) {
  return api.put(`/case/${id}/consult_call`, {
    notes: "direct order",
    tag: "direct",
  });
}

export function getCase(id) {
  const apiEndpoint = isExternalMedrep
    ? `v2/case/${id}`
    : `case/${id}`;
  return api.get(apiEndpoint);
}

export function getEngagementSlots(date) {
  return api.get(`engagement_slots?request_date=${date}`);
}

export function setReschedule(id, reminderDate) {
  return api.put(`v2/engagement/${id}`, { reminder_date: reminderDate });
}

export function setNotAnswered(id) {
  return api.post(`/consult_call/${id}/not_answered`);
}

export function setRescheduleCall(id) {
  return api.put(`case/${id}/v2/consult_call/reschedule`);
}

export function setMarkAsSingle(id, is_single_order) {
  return api.put(`singleOrder/${id}`, { is_single_order });
}

export function setSubscriptionOrder(order_id, status) {
  return api.put(`/subscriptionOrder`, { order_id, status });
}

export function makeCall(case_id, note, engagement_id, phone_number, eng=false, provider_name) {
  if (
    isEmpty(phone_number) ||
    phone_number == "undefined" ||
    phone_number == "null" ||
    phone_number.toString().trim().length == 0
  ) {
    toast.info('The phone number is appearing as blank.', TOAST_MESSAGE_CSS);
    return;
  }

  const isDoctor = ["consult_doctor", "doctor"].includes(getCurrentUserRole());

  const payload = {
    case_id,
    engagement_id,
    phone_number,
    provider_name,
    isDoctor: isDoctor || note?.isDoctor,
    note: note ? note : undefined,
  };
  const callEndPoint = isExternalMedrep ? 'v2/call' : 'call';

  return api.post(callEndPoint, payload);
}

export function getPlivoDoctors() {
  return api.get('callProvider/plivo/doctors');
}

export function transferCallToMpc(callUuid, doctorUserId, customerContext = {}) {
  return api.post('callProvider/plivo/transfer', { callUuid, doctorUserId, customerContext });
}

export function addCartLink(id, cart_link) {
  return api.post(`generate_cart_link/${id}`, { cart_link });
}

export function postCartLink(id, cart_link, cart_value, type499) {
  return api.post(`send_cart_link/${id}${type499 ? `?type=499_call` : ``}`, {
    cart_link,
    cart_value,
  });
}

export function makeCODOrder(order) {
  return isExternalMedrep
    ? api.post(`v2/cod-order`, order)
    : api.post(`cod-order`, order);
}

export function validateAddressCharacters(orderMeta) {
  return api.post(`validate-address-characters`, orderMeta);
}

// Get setting by key
export function getSetting(key) {
  return api.get(`api/clinic/settings/${key}`);
}

// Send OTP via SMS, WhatsApp, or Email (GET request with orderAmount and address for WABA)
export function sendCODOrderOTP(caseId, method, orderAmount, address = '') {
  return api.get(`cod-place-order-send-otp/${caseId}?method=${method}&orderAmount=${orderAmount}&address=${encodeURIComponent(address)}`);
}

// Verify OTP (4-digit) - GET request
export function verifyCODOrderOTP(caseId, otp) {
  return api.get(`cod-place-order-verify-otp/${caseId}?otp=${otp}`);
}

export function postComment(id, comment_text) {
  return api.post(`case/${id}/comments`, { comment_text });
}

export function putRescheduleWithComment(id, data) {
  return api.put(`v2/engagement/${id}`, data);
}

export function getConsultCallBookings(page) {
  return api.get(`pending_consult?pageNumber=${page}&pageSize=10`);
}

export function getOrders(page, flag, filter) {
  const orderStatus =
    filter && filter.length ? JSON.stringify(filter) : undefined;

  const url =
    filter && filter.length
      ? `open_orders?flag=${flag}&pageNumber=${page}&orderStatus=${encodeURIComponent(
          orderStatus
        )}`
      : `open_orders?flag=${flag}&pageNumber=${page}`;

  return api.get(url);
}

export function getRefundStatusData(orderID) {
  return api.get(`/isRefunded?orderId=${orderID}`);
}

// Fetch comprehensive refund details for an order
export function getRefundDetails(orderId) {
  return api.get(`/order/refund/details/${orderId}`);
}

// Initiate refund request
export function initiateRefund(payload) {
  return api.post(`/order/refund/initiate`, payload);
}

export function removeComment(id) {
  return api.delete(`comment/${id}`);
}

export function getTicketHistory(id) {
  return api.get(`/get-case-ticket/${id}?source=CRM`);
}

export function getUploadDocuments(id) {
  return api.get(`case-docs/${id}`);
}

export function downloadInternationalPrescriptions(userId, orderId) {
  return api.get(
    `download-international-prescription?userId=${userId}&orderId=${orderId}`
  );
}

export function getAllTag() {
  return api.get("getAllTags");
}

export function orderCancellation(payload) {
  return api.post("order-cancellation-new-api", payload);
}

export function getValidWarehouse() {
  return api.get(`get-valid-warehouses`);
}

export function checkValidWarehouse(id) {
  return api.get(`check-valid-wearhouse/${id}`);
}
export function postWarehouse(payload) {
  return api.post("order/update-fulfillment", payload);
}

export function postMarkShipped(id, payload) {
  return api.post(`order/${id}/markShipped`, payload);
}

export function postMarkDelivered(id, delivery_date) {
  return api.post(`order/${id}/markAsDelivered`, { delivery_date });
}

export function putVoidOrder(id) {
  return api.put(`void-order/${id}`);
}

export function postRTOVoidOrder(payload) {
  return api.post(`update-rto-delivered`, payload);
}

export function getOrderTRackingInfo(id) {
  return api.get(`order-tracking-info/${id}`);
}

export function markSlotFinished(caseId, payload) {
  return api.post(`v4/markDoctorSlotFinished/${caseId}`, payload)
}

export function markOrderInProgress(orderId, reason) {
  const body = reason ? { reason } : {};
  return api.put(`doctor-mark-inprogress/${orderId}`, body);
}

export const getMedicines = () => {
  return api.get("medicines");
};

export const getDosages = (order_id) => {
  return api.get(`v2/dosage/${order_id}`);
};

export const postPrescription = (order_id, prescription) => {
  return api.post(`prescription/${order_id}`, prescription);
};

export const deletePrescription = (prescriptionId) => {
  return api.delete(`prescription/${prescriptionId}`);
};

export function removeAssignedDoctor(payload) {
  return api.delete("unassign_doctor", { data: payload });
}

export function assignDoctorToOrder(payload) {
  return api.post(`assign_doctor`, payload);
}

export function autoAssign(payload) {
  return api.post(`auto_assign_doctor`, payload);
}

export function assignLeadOrder(payload) {
  return api.post("assign_order", payload);
}

export function getExpectation(case_id) {
  return api.get(`getMonthsDiagnosis/${case_id}`);
}


export function onBoardingApi(payload){
  return api.post('v4/slots/onboard-user', payload);
}

export function getDoctorSlotApi(caseId, sub_category, language, stickyDoctor = true){
  const params = {
    is_rescheduling: false,
    from_crm: true,
    sub_category:sub_category,
    non_priority: true,
    ...(stickyDoctor !== null && { sticky_doctor: stickyDoctor }),
  };
  if (language) params.language = language;
  return api.get(`v4/slots/doctor/${caseId}`, { params })
}

export function postDoctorSlot(payload){
  return api.post("v4/doctor_form_slot",payload);
}

export function allDoctor(){
  return api.get("role_doctors");
}

export function slotApi(payload){
  return api.post("v3/slots/slot-booking", payload);
}

export function getSlotApi(case_id, sessionId, isFollowUp, slot, type='', agentSlot='') {
  return api.get(slot ? `v3/slots/${case_id}?session_id=${sessionId}&lead_follow_up=${isFollowUp}${type}${agentSlot}&source=web` : `v3/slots/pc-slots?role=medical_rep&level=2`)
}

export function getSlotApiForPC(case_id, sessionId) {
  return api.get(`v3/slots/direct/${case_id}?session_id=${sessionId}&slotType=pc`);
}

export const putPrescription = (order_id, prescription) => {
  return api.put(`prescription/${order_id}`, prescription);
};

export const rootCause = (syntheticId) => {
  return api.get(`dgReport/result?id=${syntheticId}`);
};

export const caseMoengageEvents = (caseId, event_name) => {
  return api.get(`eventMoengage/${caseId}?eventName=${event_name}`)
}

export const monthKit = (caseId) => {
  return api.get(`repeat-link-crm/${caseId}`);
};

export function getMedicalSlotApi(caseId, sessionId) {
  if (!caseId || caseId === "null" || caseId === "undefined") {
    return;
  }
  return api.get(`v3/slots/${caseId}?session_id=${sessionId}&is_medical_escalation=true&source=web`);
}

export function getMedicalInterventionSlots(caseId, ticketId) {
  return api.post('medical-intervention', { case_id: caseId, ticket_id: ticketId });
}

export function getPrescriptionInfo(case_id){
  return api.get(`case/${case_id}/prescriptionCall`);
}

export function getDiscountCodeVal(payload){
  return api.post(`discount`, payload);
}

export function getRtoReattemptCategoryData(caseId, signal) {
  return api.get(`get-rto-reattempt-category?caseId=${caseId}`, { signal });
}

export function cancelFullfillment(orderNumber){
  return api.put(`cancel-fulfillment?order_number=${encodeURIComponent(orderNumber)}`)
}

export const deleteScalp = (id) =>{
  return api.delete(`deleteCaseImage/image/${id}`);
}

export function markPaidSlotFinished(caseId, payload) {
  return api.post(`v4/paid-dbooking-dispose/${caseId}`, payload);
}

export function getOldEngagementResponseData(customer_id) {
  return api.get(
    `api/authDashboard/lead-engagement-old-response/${customer_id}`
  );
}

export function hashDecryption(data = {}) {
  return api.post("/decryption",  data);
}

export function imageTag(imageId, payload) {
  return api.put(`updateCaseImage/image/${imageId}`, payload);
}

export function getFeedbackFormData(case_id, formName) {
  return api.get(`feedback-responses/${case_id}?formName=${formName}`);
}

export function getOfflineCoachAppointment(case_id, clinicId, is15DaysSlotRequired) {
  return api.get(`api/clinic/clinic-coach-slots/${case_id}`, { params: { clinic_id: clinicId, is_15_days_slot_required: is15DaysSlotRequired } });
}

export function getOfflineDoctorAppointment(case_id, clinicId, is15DaysSlotRequired) {
  return api.get(`api/clinic/clinic-slots/${case_id}`, { params: { clinic_id: clinicId, is_15_days_slot_required: is15DaysSlotRequired } });
}

export function getClinicDoctorSlots(case_id, clinicId, is15DaysSlotRequired) {
  return api.get(`api/clinic/clinic-doctor-slots/${case_id}`, { params: { clinic_id: clinicId, is_15_days_slot_required: is15DaysSlotRequired } });
}

export const bookApptSlot = (payload, clinicId) =>{
  return api.post(`api/clinic/book-store-appointment-coach-or-doctor?clinic_id=${clinicId}`, payload)
}

export const discountCode = () =>{
  return api.get(`lead-discount-codes`)
}

export const getNearestSlot = () => {
  return api.get(`v4/slots/nearest-chat-slot`);
}

export const booNearestSlot = (caseId,payload) => {
  return api.post(`/v4/slots/book-chat-slot/${caseId}`, payload);
}

export function getCaseFormResponses(case_id) {
  return api.get(`case-form-responses/${case_id}`);
}

export function getOfflineCustomerInfo(case_id) {
  return api.get(`api/clinic/customer-clinic-info/${case_id}`);
}

export function fetchStateCityFromPincode(pincode) {
  return api.get(`get-city-state?pincode=${pincode}`);
}

export function getAiSummary(case_id) {
  return api.get(`case-summary/id/${case_id}`);
}

export function getNpsCaseData(case_id) {
  return api.get(`nps/case/${case_id}`);
}

export function getRateLimitStatus(phone) {
  return api.get(`/admin/rate-limit/status`, { params: { phone } });
}

export function removeRateLimitApi(phone) {
  return api.delete(`/admin/rate-limit`, { params: { phone } });
}
